module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_ChocolatBrown.722f7729.png";